import { Store as StoreIcon } from "@mui/icons-material";
import { Box, Chip, CircularProgress, Switch, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSucursalHabilitada, updateSucursalHabilitada } from "store/slices/sucursal";

const SwitchActividad = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [estado, setEstado] = useState(false);
  const { sucursalHabilitada, isLoading } = useSelector((state) => state.sucursal);

  useEffect(() => {
    dispatch(getSucursalHabilitada());
  }, [dispatch]);

  useEffect(() => {
    setEstado(sucursalHabilitada);
  }, [sucursalHabilitada]);

  const handleChange = (event) => {
    const newEstado = event.target.checked;
    setEstado(newEstado);
    dispatch(
      updateSucursalHabilitada({
        estado: newEstado,
      })
    );
  };

  if (isLoading) {
    return <CircularProgress size={24} />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        width: "100%",
        py: 0.5,
      }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: estado ? theme.palette.success.main : theme.palette.text.secondary,
        }}>
        <StoreIcon fontSize="small" />
        <Typography variant="body2" fontWeight={500}>
          Tienda
        </Typography>
      </Box>

      <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
        <Chip
          label={estado ? "Abierta" : "Cerrada"}
          size="small"
          sx={{
            backgroundColor: estado ? theme.palette.success.main : theme.palette.grey[400],
            color: theme.palette.common.white,
            fontWeight: 600,
            fontSize: "0.75rem",
            height: 24,
          }}
        />
      </Box>

      <Switch
        checked={estado}
        onChange={handleChange}
        size="small"
        sx={{
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: theme.palette.success.main,
            "&:hover": {
              backgroundColor: `${theme.palette.success.main}14`,
            },
          },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: theme.palette.success.main,
          },
        }}
      />
    </Box>
  );
};

export default SwitchActividad;
